<template>
  <div style="height:100%;padding:0.1rem;"
       v-if="show" :style="horizontalStyle">
    <div class="mydraw">
      <!-- clear -->
      <!-- save -->
      <div class="canvasContainer" :style="sign_for_horiz?'max-height: 100%;height: 100%;widht:100%;':''">
        <div class="signTitle">
          <span>请签名：<van-switch v-model="sign_for_horiz" size="12px"  /> 采用横向签名签名</span>
          
          <span style="color:red;"
                @click="closeSpad">关闭</span>
        </div>
        <div v-if="presigninfo"
             v-html="presigninfo"
             :class="showCanvas ? 'signDesc' : 'otherSignDesc'"
             :style="sign_for_horiz?'height: 1rem;overflow-y: auto;':''"
             ></div>
        <div>
          <div class="yingcangCanvas"
               @click="showCanvas = !showCanvas">
            <van-icon :name="showCanvas ? 'arrow-down' : 'arrow-up'" />
            {{ showCanvas ? '收起签名栏' : '展开签名栏' }}
          </div>
        </div>
        <div v-show="showCanvas"
             class="cont canvasDiv"
             style="display:block" :style="sign_for_horiz?'height: calc(100% - 4.533334rem) !important;':''">
          <canvas style="background:#fff;"
                  id="canvas"
                  ref="mycanvas"
                  @touchstart="onTouchStart"
                  @touchmove="onTouchMove"
                  @touchend="onTouchEnd">Canvas画板</canvas>
        </div>
        <div class="signFooter">
          <div class="button_can"
               @click="clear">重写</div>
          <div class="button_def"
               @click="save">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Dialog, Toast,Notify } from 'vant'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    presigninfo: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      direction: 'vertical', // 画板方向 vertical horizontal
      colors: [
        { color: 'black', active: true },
        { color: 'red', active: false },
        { color: 'blue', active: false }
      ], // 可选颜色
      ctx: '', // canvas对象
      stage_info: '', // mycanvas的大小及其相对于视口的位置
      canvasWidth: '', // canvas宽度
      canvasHeight: '', // canvas高度
      huabuWidth: '',
      huabuHeight: '',
      lineColor: 'black', // 线条的颜色
      lineWidth: 2, // 线条宽度
      url: '',
      urlorg: '',
      urlset: '',
      signData: {
        // 提交签名需要的内容
        lawCaseId: '',
        litigantId: '',
        lawyerId: '',
        image: ''
      },
      saveLoading: false, // 保存按钮加载状态
      showCanvas: true,
      sign_for_horiz:false
    }
  },
  computed: {
     // 是否采用横向签名样式
    signatureStyle() {
      if (this.sign_for_horiz) {
        return ' width: 100%; height:100% '
      } else {
        return ' width: 96%;'
      }
    },
    // 是否采用横向签名样式
    horizontalStyle() {
      const winWidth = document.documentElement.scrollWidth
      const winHeight = document.documentElement.scrollHeight
      const top = (winHeight - winWidth) / 2
      const left = 0 - (winHeight - winWidth) / 2
      if (this.sign_for_horiz) {
        return `transform: rotate(90deg); width: ${winHeight}px;height: ${winWidth}px; position: absolute; top: ${top}px; left: ${left}px; transform-origin: 50% 50%;`
      } else {
        return ' width: 100%; height:100% '
      }
    }
  },
  watch: {
    show: {
      handler (n) {
        if (n)
        {
          setTimeout(() => {
            this.writeName()
          }, 50)
        }
      },
      deep: true,
      immediate: true
    },
    sign_for_horiz: {
      handler (n) {
        if (n)
        {
          setTimeout(() => {
            this.writeName()
          }, 50)
        }
      }
    }
  },
  created () {
    // 阻止默认微信系统字体大小的影响
    if (
      typeof WeixinJSBridge == 'object' &&
      typeof WeixinJSBridge.invoke == 'function'
    )
    {
      handleFontSize()
    } else
    {
      if (document.addEventListener)
      {
        document.addEventListener('WeixinJSBridgeReady', handleFontSize, false)
      } else if (document.attachEvent)
      {
        document.attachEvent('WeixinJSBridgeReady', handleFontSize)

        document.attachEvent('onWeixinJSBridgeReady', handleFontSize)
      }
    }

    function handleFontSize () {
      // 设置网页字体为默认大小
      WeixinJSBridge.invoke('setFontSizeCallback', {
        fontSize: 0
      })
      // 重写设置网页字体大小的事件
      WeixinJSBridge.on('menu:setfont', function () {
        WeixinJSBridge.invoke('setFontSizeCallback', {
          fontSize: 0
        })
      })
    }
  },

  methods: {
    // 点击签名，初始化画板
    writeName () {
      this.url = ''
      this.$nextTick(() => {
        this.initCanvas()
      })
    },
    /**
     * 初始化画板，获取canvas节点对象，设置画板的宽高
     * 不能在此方法中设置线条宽度样式，否则无效
     */
    initCanvas () {
      // 获取到当前canvas节点的信息，包含宽，高，top，left等
      var mycanvas = this.$refs.mycanvas // 获取canvas元素
      this.huabuWidth = document.body.clientWidth * 0.92
      this.huabuHeight = document.body.clientHeight * 0.5
      this.canvasWidth = mycanvas.clientWidth - 1 // 获取画板宽度
      this.canvasHeight = mycanvas.clientHeight - 1 // 获取画板高度
      // 设置canvas自适应的宽高到标签上（重要,canvas一定要遭标签上标识宽高，否则坐标获取不准确）
      // console.log('clientWidth', this.canvasWidth)
      // console.log('clientHeight', this.canvasHeight)
      mycanvas.width = this.canvasWidth
      mycanvas.height = this.canvasHeight

      // canvas基础设置，线条设置
      this.ctx = mycanvas.getContext('2d')
      // 获取mycanvas的大小及其相对于视口的位置
      this.stage_info = mycanvas.getBoundingClientRect()
      this.urlorg = mycanvas.toDataURL()
      // console.log('stage_info', this.stage_info)
      if (this.urlset)
      {
        let u =
          this.urlset.trim() +
          (this.urlset.indexOf('http') > -1
            ? '?v=' + Date.parse(new Date())
            : '')
        this.ctx.beginPath()
        let img = new Image()
        // 图片跨域问题
        img.crossOrigin = 'anonymous'
        img.src = u
        img.onload = () => {
          //判断图片是否加载成功
          this.ctx.drawImage(img, 0, 0)
        }
      }
    },
    /**
     * 绘制笔触
     */
    handleDraw (targetX, targetY) {
      // console.log(targetX, targetY)
      this.ctx.lineTo(targetX, targetY) // 将笔触移到当前点击点
      this.ctx.stroke()
    },
    /**
     * 触摸开始
     * 获取当前点击点的坐标
     * 设置线条颜色，宽度，样式等
     */
    onTouchStart (e) {
      const clientX = e.changedTouches[0].clientX
      const clientY = e.changedTouches[0].clientY
      const top = this.stage_info.top;
      const left = this.stage_info.left;
      const bottom = this.stage_info.bottom
      const right = this.stage_info.right
      let targetX = 0
      let targetY = 0
      // 当采用横向签名时重新计算坐标
      if (this.sign_for_horiz)
      {
        targetX = clientY - top // 计算起始点X坐标
        targetY = -(clientX - right) // 计算起始点Y坐标
      } else
      {
        targetX = clientX - left  // 计算起始点X坐标
        targetY = clientY - top // 计算起始点Y坐标
      }
      e.preventDefault();
      this.ctx.beginPath();
      this.ctx.strokeStyle = this.lineColor; // 设置线条颜色
      this.ctx.lineWidth = this.lineWidth; // 设置线条的宽度
      this.ctx.lineCap = "round"; // 设置线条的端点的样式，设为圆弧形
      this.ctx.lineJoin = "round"; // 设置线条的连接点的样式，设为弧形
      this.handleDraw(targetX, targetY);
    },
    /**
     * 触摸过程中
     * 获取并计算当前点击点的坐标，绘制线条
     */
    onTouchMove (e) {
      const clientX = e.changedTouches[0].clientX
      const clientY = e.changedTouches[0].clientY
      const top = this.stage_info.top;
      const left = this.stage_info.left;
      const bottom = this.stage_info.bottom
      const right = this.stage_info.right
      let targetX = 0
      let targetY = 0
      // 当采用横向签名时重新计算坐标
      if (this.sign_for_horiz)
      {
        targetX = clientY - top // 计算起始点X坐标
        targetY = -(clientX - right) // 计算起始点Y坐标
      } else
      {
        targetX = clientX - left  // 计算起始点X坐标
        targetY = clientY - top // 计算起始点Y坐标
      }
      e.preventDefault();
      this.handleDraw(targetX, targetY);
    },
    /**
     * 触摸结束
     */
    onTouchEnd (e) {
      e.preventDefault()
    },
    /**
     * 颜色模块点击事件，切换点击的颜色状态
     */
    clickColorItem (e) {
      this.colors.forEach(item => {
        item.active = false
      })
      e.active = true
      this.lineColor = e.color // 设置当前笔触颜色
    },
    /**
     * 重写按钮点击事件，清空画板内容
     */
    clear () {
      // 清空图片
      this.url = ''
      this.urlset = ''
      // 清空画板
      this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
      // 重新设置canvas画板节点对象，否则绘画会出问题,这里异步操作，否则绘画有误
      this.$nextTick(() => {
        this.initCanvas()
      })
    },
    // 保存签名
    save () {
      Dialog.confirm({
        title: '系统提示',
        message: '您确定提交吗？'
      })
        .then(() => {
          this.url = this.$refs.mycanvas.toDataURL()
          console.log(this.url,'11111111',this.urlorg);
          
          if (this.url != this.urlorg)
          {
          this.submitText()
          } else
          {
            Notify({
              type: 'danger',
              message: '请签名！'
            })
            return
          }
        })
        .catch(() => {
          // on cancel
        })
    },
    closeSpad () {
      // this.show = false;
      this.$emit('closeSpad', false)
    },
    // 提交签名图片
    submitText () {
      if (this.url != '')
      {
        // 追加base64签名图片,转换角度(横屏不需要旋转图片角度)
        this.rotateBase64Img(this.url, this.direction == 360, base64data => {
          this.signData.image = base64data
          this.$emit('getSpad', base64data)
        })
      } else
      {
      }
    },
    // 旋转base64图片
    rotateBase64Img (src, edg, callback) {
      // 旋转base64图片
      var canvas = document.createElement('canvas')
      var ctx = canvas.getContext('2d')

      var imgW // 图片宽度
      var imgH // 图片高度
      var size // canvas初始大小
      if (edg % 90 != 0)
      {
        console.error('旋转角度必须是90的倍数!')
        throw '旋转角度必须是90的倍数!'
      }
      edg < 0 && (edg = (edg % 360) + 360)
      const quadrant = (edg / 90) % 4 // 旋转象限
      const cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 } // 裁剪坐标
      var image = new Image()
      image.crossOrigin = 'anonymous'
      image.src = src
      image.onload = function () {
        imgW = image.width
        imgH = image.height
        size = imgW > imgH ? imgW : imgH
        canvas.width = size * 2
        canvas.height = size * 2
        switch (quadrant)
        {
          case 0:
            cutCoor.sx = size
            cutCoor.sy = size
            cutCoor.ex = size + imgW
            cutCoor.ey = size + imgH
            break
          case 1:
            cutCoor.sx = size - imgH
            cutCoor.sy = size
            cutCoor.ex = size
            cutCoor.ey = size + imgW
            break
          case 2:
            cutCoor.sx = size - imgW
            cutCoor.sy = size - imgH
            cutCoor.ex = size
            cutCoor.ey = size
            break
          case 3:
            cutCoor.sx = size
            cutCoor.sy = size - imgW
            cutCoor.ex = size + imgH
            cutCoor.ey = size + imgW
            break
        }
        ctx.translate(size, size)
        ctx.rotate((edg * Math.PI) / 180)
        ctx.drawImage(image, 0, 0)
        ctx.fillStyle = '#fff'
        var imgData = ctx.getImageData(
          cutCoor.sx,
          cutCoor.sy,
          cutCoor.ex,
          cutCoor.ey
        )
        if (quadrant % 2 == 0)
        {
          canvas.width = imgW
          canvas.height = imgH
        } else
        {
          canvas.width = imgH
          canvas.height = imgW
        }
        ctx.putImageData(imgData, 0, 0)
        callback(canvas.toDataURL())
      }
    },
    // 导入历史签名
    setSign (url) {
      this.urlset = url
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
body {
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}

.cont {
  /* display: inline-block; */
  /* vertical-align: middle; */
}

.cont p {
  transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
}

.buttonDiv {
  width: 15%;
}

.buttonDiv2 {
  height: 15%;
  -moz-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.commoBtn button {
  transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  margin: 20px 0px;
}

.commoBtn2 button {
  display: inline-block;
  margin: 10px;
}

.canvasContainer {
  width: 96%;
  // height: 50%;
  max-height: 80%;
  background: #fff;
  border-radius: 16px;
}
.canvasContainer .signTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 28px;
  color: #666;
  height: 60px;
  padding-left: 3%;
  padding-right: 4%;
  border-bottom: 1px solid #ccc;
}
.canvasContainer .signDesc {
  height: auto;
  padding-left: 3%;
  padding-right: 4%;
  margin: 20px 0;
  font-size: 28px;
  color: #666;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  // max-height: calc(100% - 810px);
  max-height: 540px;
}
.canvasContainer .otherSignDesc {
  height: auto;
  padding-left: 3%;
  padding-right: 4%;
  margin: 20px 0;
  font-size: 28px;
  color: #666;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  // max-height: calc(100% - 810px);
  max-height: 1000px;
}

.canvasContainer .yingcangCanvas {
  display: flex;
  align-items: center;
  justify-content: center;
  // background-color: #999;
  // margin-left: 3%;
  // margin-right: 4%;
  font-size: 28px;
  color: #2b8df0;
}
.canvasContainer .signFooter {
  height: 90px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  border-top: 1px solid #ccc;
  margin-top: 20px;
  .button_can {
    width: 50%;
    text-align: center;
    border-right: 1px solid #ccc;
    color: #999;
    font-size: 28px;
    height: 100%;
    line-height: 90px;
  }
  .button_def {
    width: 50%;
    text-align: center;
    font-size: 28px;
    color: #2b8df0;
    height: 100%;
    line-height: 90px;
  }
}
.canvasDiv {
  width: 92% !important;
  // height: calc(100% - 170px) !important;
  height: 300px !important;
  position: relative;
  margin: 0 auto;
  // display: block !important;
}

.canvasDiv2 {
  height: 70%;
  width: 100%;
  position: relative;
  transform: rotate(180deg);
}

.signLabelDiv {
  width: 12%;
  font-size: 0.3rem;
}

.signLabelDiv2 {
  height: 12%;
  font-size: 0.3rem;
  transform: rotate(90deg);
  margin-left: -4.5%;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;

  padding: 0;
}

li {
  display: inline-block;

  margin: 0 10px;
}

a {
  color: #42b983;
}

#canvas {
  background: #fff;
  cursor: default;
  border: 1px dashed rgb(204, 204, 204);
  /* 判断方向旋转辅助线 */
  /* border-bottom: 1px solid red; */
  height: 100%;
  width: 100%;
}

.mydraw {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mydraw2 {
  height: 100%;
  width: 100%;
  transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
}
</style>
